import EditorPageMenu from './Component';

export { default as onKeyDown } from './onKeyDown';
export { default as usePageMenu, PageMenuProvider } from './usePageMenu';

export default EditorPageMenu;
